<template>
  <v-autocomplete
    v-model="cidade"
    :items="cidades"
    :loading="isCidadesLoading"
    :search-input.sync="search"
    item-text="descr"
    item-value="codigo"
    label="Cidade"
    placeholder="Digite o nome da cidade para pesquisar"
    hide-select
    return-object
    @input="onInput"
  >
    <template slot="item" slot-scope="{ item }">{{ item.descr }} - {{ item.uf }}</template>
  </v-autocomplete>
</template>
<script>
import localidadeService from '@/services/localidade'
import _ from 'lodash'

export default {
  name: 'e-select-cidade2',
  props: ['value', 'localidade', 'uf'],
  data () {
    return {
      cidades: [],
      cidade: {},
      currentSearch: '',
      isCidadesLoading: false,
      search: null
    }
  },
  mounted () {
    _.delay(() => {
      if ((this.value !== undefined) && (this.localidade !== undefined) && (this.uf !== undefined)) {
        this.forceValue(this.value, this.localidade, this.uf)
      }
    }, 500)
  },
  watch: {
    search (str) {
      this.currentSearch = str
      _.delay(() => {
        if (this.currentSearch === str) {
          if (this.isCidadesLoading) return // já está pesquisando
          if (str === '') return // cidade vazia...
          this.isCidadesLoading = true
          localidadeService.getByNome(str).then(r => {
            this.cidades = r
          }).finally(() => (this.isCidadesLoading = false))
        }
      }, 500)
    }
  },
  methods: {
    onInput (item) {
      this.$emit('userSelect', item)
    },
    forceValue (codigo, localidade, uf) {
      this.isCidadesLoading = true
      this.cidade = { 'codigo': codigo, 'descr': localidade, 'uf': uf }
      this.cidades.push(this.cidade)
      _.delay(() => {
        this.isCidadesLoading = false
      }, 1000)
    }
  }
}
</script>
